<template>
  <div class="examList">
    <el-table v-if="examList.length > 0" :data="examList" class="table-container" :height="tableHeight" ref="paramRef"
      :row-style="{ height: rowHeight + 'px' }" :cell-style="{ padding: 7 + 'px' }">
      <el-table-column align="center" type="index" />
      <el-table-column align="center" label="院校名称" prop="institutionName" width="150" />
      <el-table-column align="center" label="考点名称" prop="title" width="150" />
      <el-table-column align="center" label="报名费用" prop="price">
        <template slot-scope="scope"> {{ scope.row.price }}元 </template>
      </el-table-column>
      <el-table-column align="center" label="报名开始时间" prop="applyStartTime" width="200">
        <template slot-scope="{ row }">
          <span>
            {{ row.applyStartTime | parseTimes }}
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="报名结束时间" prop="applyEndTime" width="200">
        <template slot-scope="{ row }">
          <span>
            {{ row.applyEndTime | parseTimes }}
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="报名状态" prop="status.msg" />
      <el-table-column align="center" label="操作" fixed="right" width="120">
        <template slot-scope="{ row }">
          <el-button v-if="row.examUserStatus === 'NoRegistered' && row.status.code === 1" type="primary" size="small"
            @click="apply(row)">
            报名
          </el-button>
          <el-button v-if="row.examUserStatus === 'Registered'" type="primary" size="small" @click="apply(row)"
            style="opacity: 0.5">
            已报名
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-empty v-else class="enpty" description="暂无考试"></el-empty>

    <!-- 个人信息弹窗 -->
    <modal :modalShow="modalShow" @cancel="modalShow = false" @close="modalShow = false" @register="register" :row="row"
      isFirst="true">
    </modal>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { parseTime } from '@/utils/time'
import Modal from '@/components/Modal.vue'
import Vue from 'vue'
import moment from 'moment'

export default {
  components: { Modal },
  data() {
    return {
      rowHeight: 0, //表格行高
      tableHeight: window.innerHeight - 245,
      // modalDataList: [], //弹窗数据
      modalShow: false, //弹窗是否显示
      // modalSubjectList: [],//考试科目列表
      row: {},

      listQuery: {
        pageNum: 1,
        pageSize: 10,
        condition: {
          noShowUserId: '',
          // institutionId
          institutionId: 0,
          userId: 0,
          status: 1
        }
      },
      total: 0,
      examUserBaseI: '',
      examInfo: {},
      dialogFormVisible: false
    }
  },
  watch: {
    examList(newValue, oldValue) {
      if (!newValue.length) return
      if (!this.$route.query?.id) return

      const row = newValue.find(it => it.id === +this.$route.query.id)
      if (!row) return
      this.apply(row)
    }
  },
  mounted() {
    this.examUserBaseI = JSON.parse(localStorage.userInfo) || ''
    this.getUserInfo()


  },
  filters: {
    parseTime(val) {
      return parseTime(val, '{y}-{m}-{d}') || '--'
    },
    parseTimes(val) {
      return parseTime(val, '{y}-{m}-{d} {h}:{i}:{s}') || '--'
    }
  },
  computed: {
    ...mapState({
      examList: state => state.register.examList.filter(item => item.status.enumCode === 'Start')
    }),
    rangeTime() {
      console.log(tiem, 999);
      return time => moment().isBetween(...time)
    }
  },
  methods: {
    getList() {
      this.listQuery.condition.institutionId = JSON.parse(localStorage.getItem('fstat')).institutionId
      this.listQuery.condition.userId = JSON.parse(localStorage.getItem('fstat')).userId
      this.examUserBaseI = JSON.parse(localStorage.userInfo) || ''
      this.getExamList()
    },
    getUserInfo() {
      const { userId } = this.examUserBaseI
      this.$store.dispatch('getUserInfo', userId).then(res => {
        console.log('main', res, res.fstat)
        localStorage.setItem('fstat', JSON.stringify(res) || '{}')
        // if(res.fstat !==1){
        //     this.dialogVisible = true;
        // }
        if (localStorage.getItem('redirectTo')) {
          this.$router.replace(localStorage.getItem('redirectTo'))
          localStorage.removeItem('redirectTo')
        }
        this.getList()
      })
    },
    initRowHeight() {
      let tableHeight =
        Math.round(this.$refs['paramRef'].$el.offsetHeight) -
        Math.round(this.$refs['paramRef'].$el.childNodes[1].offsetHeight)
      // 返回小于等于最终结果的最大整数
      this.rowHeight = Math.floor(tableHeight / 10)
    },
    cancel() {
      this.modalShow = false
      this.modalDataList = []
    },
    //检查是否报名
    checkedSigup() {
      const { userId } = this.examUserBaseI
      const params = {
        userId
      }
      this.$store
        .dispatch('checkedSigup', params)
        .then(res => {
          //检查是否已经报名
        })
        .catch(err => {
          console.log(err)
        })
    },

    // 获取考试列表
    getExamList() {
      console.log(this.$route.path, 888);


      const {institutionId,userIdCardBack,userIdCardFront,avatar} = JSON.parse(localStorage.getItem('fstat'))
      if(!(institutionId&&userIdCardBack&&userIdCardFront&&avatar)){
        this.$message.warning('请在“个人中心”完善用户信息')
        this.$router.push({ path: '/personalCenter' })
        return
      }
      this.$router.push({ path: '/register' })
      this.listQuery.condition.noShowUserId = JSON.parse(localStorage.getItem('fstat')).id
      console.log(this.listQuery.noShowUserId, this.listQuery)
      this.$store
        .dispatch('getExamList', this.listQuery)
        .then(res => {
          this.total = res.total
          if (res.total) {
            this.initRowHeight()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 报名弹窗
    async apply(row) {
      if (row.examUserStatus === 'NoRegistered' && row.status.code === 1) {
        const res = await this.$alert(row.description, '考试描述', {
          dangerouslyUseHTMLString: true,
          customClass: "exam-description-content-wrapper",
          confirmButtonText: '我已阅读',
        });
        if(!res) return;
      }


      this.modalShow = true
      this.examInfo = row
      this.row = row
      // 如果资料未完善，不能报名
      if (!JSON.parse(localStorage.getItem('fstat'))) {
        Vue.showConfirm()
        return
      }
    },

    beforeAvatarUpload() { },
    /* 报名考试 */
    register(list) {
      const examUserBaseI = this.examUserBaseI
      const params = list.slice(0, -1).map(item => {
        return {
          infoKey: item.infoKey,
          infoName: item.infoName,
          infoType: item.infoType,
          infoValue: item.prop,
          examUserBaseId: examUserBaseI.userId
        }
      })

      let result = {
        // id: this.row.id,
        examId: this.examInfo.id,
        examUserBaseId: examUserBaseI.userId,
        examUserExtendParams: params,
        examDetailIds: list.slice(-1)[0].examDetailIds
      }

      // console.log('result==', result);
      // return
      this.$store
        .dispatch('submitPersonInfo', result)
        .then(res => {
          //判断状态，关闭弹窗
          this.$message.success('报名成功')
          this.modalShow = false
          this.getExamList()
        })
        .catch(err => {
          // this.$message.success(err);
        })
    }
  }
}
</script>
<style lang="scss" scoped>
@media screen and (min-width: 320px) and (max-width: 768px) {
  @import '../styles/main.mobile.scss';
}

@media screen and (min-width: 769px) {
  @import '../styles/main.pc.scss';
}
</style>
<style lang="scss">
.exam-description-content-wrapper{
  width: 600px;
  .el-message-box__content{
    height: 600px;
    overflow-y: auto;
  }
}
</style>
